import { ChangeDetectionStrategy, Component, inject, input, InputSignal, output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';

import { LabelFormType } from '@connect-services/client/components/project-settings/symbology-edit/symbology-edit.component';
import { SymbologyEditService } from '@connect-services/client/services/symbology-edit.service';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { FormService } from '@shared/client/services/form.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-symbology-label-form',
    styleUrl: '../../edit-deposit-layer/edit-deposit-layer.component.scss',
    templateUrl: './symbology-label-form.component.html',
})
export class SymbologyLabelFormComponent {
    public readonly formGroup: InputSignal<FormGroup<LabelFormType>> = input.required();
    public readonly onLabelChange = output<MatSelectChange>();

    protected readonly formService = inject(FormService);
    protected readonly symbologyEditService = inject(SymbologyEditService);
}
